import { useTranslation } from "react-i18next";
import SvgPackage from "components/svg/SvgPackage";
import { Card, Tab, Tabs } from "react-bootstrap"
import SvgShuffle from "components/svg/SvgShuffle";
import ObjectCardProducts from "./Tabs/ObjectCardProducts";
import ObjectCardOther from "./Tabs/ObjectCardOther";
import SvgMenu from "components/svg/SvgMenu";
import ObjectCardEvents from "./Tabs/ObjectCardEvents";

const OffObjectCardTabs = ({objectId, vobjectFull, setVobjectFull, fetchObject}) => {
    const { t } = useTranslation(['Objects']);
    return (
        <Tabs
            variant="underline" 
            defaultActiveKey="products"
            className="mb-3 invoice-tab  border-bottom px-3">
            
            <Tab eventKey="products" 
                title={(<><SvgPackage height={14} className="me-1"/>{t('infoItems.objectMaterials')}</>) }>
                    <ObjectCardProducts vobjectFull={vobjectFull}/>
            </Tab>

            <Tab eventKey="other"
                title={(<><SvgShuffle height={14} className="me-1"/>{t('infoItems.objectOther')}</>) }>
                    <ObjectCardOther
                        setVobjectFull={setVobjectFull}
                        fetchObject={fetchObject}    
                        objectId={objectId}
                        vobjectFull={vobjectFull}/>
            </Tab>   
 
            {vobjectFull?.events?.length > 0 &&
            (<Tab eventKey="events"
                title={(<><SvgMenu height={14} className="me-1"/>{t('infoItems.objectEvents')}</>) }>
                <ObjectCardEvents
                    vobjectFull={vobjectFull}/>
            </Tab>)}
                                    
        </Tabs>
    )
}

export default OffObjectCardTabs;